import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface CartEventEntityParams {
  location: string;
  product_line?: string;
  distributor?: string;
}
export class CartEventEntity extends BaseEntityClass {
  location: string;
  product_line?: string;
  distributor?: string;
  constructor(params: CartEventEntityParams) {
    super();
    this.type = "cart_event";
    this.entity_version = 2;
    this.location = params.location;
    this.product_line = params.product_line;
    this.distributor = params.distributor;
  }
}
